import { DEFAULT_DATATABLE_SETTINGS } from 'components/datatable/constants';
import type { DatatableState } from 'components/datatable/datatable.types';
import { TimesheetScopes } from 'components/timesheets/types';

export const getDefaultTimesheetDatatableState = (scope: TimesheetScopes): DatatableState => {
  return {
    columns: [
      {
        id: 'selection',
        isVisible: true,
        pinned: false,
      },
      {
        id: 'day',
        isVisible: true,
        pinned: false,
      },
      {
        id: 'name',
        isVisible: scope !== TimesheetScopes.User,
        pinned: false,
      },
      {
        id: 'project',
        isVisible: scope !== TimesheetScopes.Project,
        pinned: false,
      },
      {
        id: 'notes',
        isVisible: true,
        pinned: false,
      },
      {
        id: 'tags',
        isVisible: true,
        pinned: false,
      },
      {
        id: 'client',
        isVisible: false,
        pinned: false,
      },
      {
        id: 'billable',
        isVisible: false,
        pinned: false,
      },
      {
        id: 'state',
        isVisible: true,
        pinned: false,
      },
      {
        id: 'logged_hours',
        isVisible: true,
        pinned: false,
      },
      {
        id: 'logged_money',
        isVisible: false,
        pinned: false,
      },
      {
        id: 'estimated_hours',
        isVisible: false,
        pinned: false,
      },
      {
        id: 'estimated_money',
        isVisible: false,
        pinned: false,
      },
      {
        id: 'linked_work_id',
        isVisible: false,
        pinned: false,
      },
      {
        id: 'linked_work_title',
        isVisible: false,
        pinned: false,
      },
      {
        id: 'linked_work_status',
        isVisible: false,
        pinned: false,
      },
      {
        id: 'linked_work_jira_custom_field',
        isVisible: false,
        pinned: false,
      },
    ],
    settings: DEFAULT_DATATABLE_SETTINGS,
  } as const;
};
